import { Injectable } from "@angular/core";
import { Http, Headers, Response, RequestOptions } from "@angular/http";
import { Observable } from "rxjs";
import { environment } from "../../environments/environment";
import "rxjs/add/operator/map";
import { Dealer } from "../_models/dealer";
// new change -- for get user model object
import { User } from "../_models/user";
import { AuthenticationService } from "../_services/authentication.service";
import { EnvironmentService } from "./index";

@Injectable()
export class DealersService {
  private baseUrl: string = this.environmentService.getBaseURL() + "/api";

  constructor(
    private http: Http,
    private authenticationService: AuthenticationService,
    private environmentService: EnvironmentService
  ) {}

  getAll(): Observable<Dealer[]> {
    let dealers$ = this.http
      .get(`${this.baseUrl}/dealers`, this.makeHeaders())
      .map(mapDealers)
      .catch(handleError);
    return dealers$;
  }
  getAllWithEmployees(): Observable<Dealer[]> {
    let dealers$ = this.http
      .get(`${this.baseUrl}/dealers?populate=employees`, this.makeHeaders())
      .map(mapDealers)
      .catch(handleError);
    return dealers$;
  }
  get(id: string): Observable<Dealer> {
    let dealer$ = this.http
      .get(
        `${this.baseUrl}/dealers/${id}?populate=employees&populate=cars`,
        this.makeHeaders()
      )
      .map(mapDealer);
    return dealer$;
  }
  create(dealer: Dealer): Observable<Dealer> {
    let newdealer = this.http
      .post(
        `${this.baseUrl}/dealers`,
        JSON.stringify(dealer),
        this.makeHeaders()
      )
      .map(mapDealer);
    return newdealer;
  }
  saveuser(user: User): Observable<Dealer> {
    let newuser = this.http
      .post(`${this.baseUrl}/users`, JSON.stringify(user), this.makeHeaders())
      .map(mapDealer);
    return newuser;
  }
  read(id: string): Observable<Dealer> {
    let dealer = this.http
      .get(`${this.baseUrl}/dealers/${id}`, this.makeHeaders())
      .map(mapDealer);
    return dealer;
  }
  update(dealer: Dealer): Observable<Response> {
    console.log(dealer);
    return this.http.put(
      `${this.baseUrl}/dealers/${dealer._id}`,
      JSON.stringify(dealer),
      this.makeHeaders()
    );
  }
  serviceToggle(
    dealer: Dealer,
    _service: string,
    _toggle: boolean
  ): Observable<Response> {
    
    var response = this.http
      .post(
        `${this.baseUrl}/toggleDealerService/`,
        JSON.stringify({
          dealerId: dealer._id,
          service: _service,
          toggle: _toggle,
        }),
        this.makeHeaders()
      )
      .map((res: Response) => res.json());
    return response;
  }
  delete(id: string): Observable<Response> {
    return this.http
      .delete(`${this.baseUrl}/dealers/${id}`, this.makeHeaders())
      .map((res: Response) => res.json()) // ...and calling .json() on the response to return data
      .catch((error: any) =>
        Observable.throw(error.json().error || "Server error")
      ); //...errors if any
  }

  // New method to update KM settings
  updateKmSettings(
    dealerId: string, 
    kmOverExceed: number, 
    kmUnderExceed: number, 
    kmOverPercentage: number, 
    kmUnderPercentage: number
  ): Observable<any> {
    const baseUrl = environment.production 
      ? this.environmentService.getBaseURL()
      : "http://localhost:3004";
    const url = `${baseUrl}/new-api/dealers/save-km-over-under/${dealerId}`;
    
    const data = {
      monitorKmOverExceed: kmOverExceed,
      monitorKmUnderExceed: kmUnderExceed,
      monitorKmOverPercentage: kmOverPercentage,
      monitorKmUnderPercentage: kmUnderPercentage
    };
    
    let headers = new Headers();
    headers.append("Authorization", this.authenticationService.getToken());
    headers.append("Content-Type", "application/json");
    
    let options = new RequestOptions({ headers: headers });
    
    return this.http.patch(url, JSON.stringify(data), options);
  }

  private makeHeaders(): RequestOptions {
    let headers = new Headers();

    headers.append("Authorization", this.authenticationService.getToken());
    headers.append("Content-Type", "application/json");
    headers.append("charset", "UTF-8");
    headers.append("Accept", "application/json");
    headers.append("Access-Control-Allow-Origin", "*");
    headers.append("Access-Control-Allow-Methods", "GET, POST, PUT, DELETE");
    headers.append("Access-Control-Allow-Headers", "Content-Type");
    headers.append("Access-Control-Allow-Credentials", "true");

    let options = new RequestOptions({ headers: headers });
    return options;
  }

  private makePostHeaders(): RequestOptions {
    let headers = new Headers();

    headers.append("Authorization", this.authenticationService.getToken());
    headers.append("Content-Type", "application/json ");
    headers.append("charset", "UTF-8 ");
    headers.append("Accept", "application/json ");
    headers.append("Method", "POST");
    headers.append("Access-Control-Allow-Origin", "*");

    let options = new RequestOptions({ headers: headers });
    return options;
  }
}
function mapDealers(response: Response): Dealer[] {
  // uncomment to simulate error:
  // throw new Error('ups! Force choke!');
  return response.json().map(toDealer);
}

function toDealer(r: any): Dealer {
  let dealer = <Dealer>{
    _id: r._id,
    name: r.name,
    url: r.url,
    cars: r.cars,
    employees: r.employees,
    list1: r.list1,
    list2: r.list2,
    list1_name: r.list1_name,
    list2_name: r.list2_name,
    company: r.company,
    from_name: r.from_name,
    from_email: r.from_email,
    subject: r.subject,
    language: r.language,
    state: r.state,
    country: r.country,
    permission_reminder: r.permission_reminder,
    email_type_option: r.email_type_option,
    logo: r.logo,
    phone: r.phone,
    address1: r.address1,
    address2: r.address2,
    zip: r.zip,
    city: r.city,
    payment_method: r.payment_method,
    dealerCode: r.dealerCode,
    serviceAgreementEnabled: r.serviceAgreementEnabled,
    tyreHotelEnabled: r.tyreHotelEnabled,
    usedCarEnabled: r.usedCarEnabled,
    prolongingsEnabled: r.prolongingsEnabled,
    serviceIntervalsEnabled: r.serviceIntervalsEnabled,
    monitorKmEnabled: r.monitorKmEnabled,
    usedCarsPeriodEnabled: r.usedCarsPeriodEnabled,
    usedCarPeriodCheapestEnabled: r.usedCarPeriodCheapestEnabled,
    usedCarPeriodLongestEnabled: r.usedCarPeriodLongestEnabled,
    usedCarPeriodExtraYearEnabled: r.usedCarPeriodExtraYearEnabled,
    tyreMountingPrice: r.tyreMountingPrice,
    tyrePaymentTerms: r.tyrePaymentTerms,
    tyreDataNote: r.tyreDataNote,
    tyreQualityNote: r.tyreQualityNote,
    tyreChoiceNote: r.tyreChoiceNote,
    maxKms: r.maxKms,
    maxYears: r.maxYears,
    usedCarPaymentTerms: r.usedCarPaymentTerms,
    usedCarAlternativeLenghtNote: r.usedCarAlternativeLenghtNote,
    usedCarYearKmNote: r.usedCarYearKmNote,
    prolongingsPaymentTerms: r.prolongingsPaymentTerms, 
    prolongingsYearKmNote: r.prolongingsYearKmNote,
    monitorKmOverExceed: r.monitorKmOverExceed,
    monitorKmUnderExceed: r.monitorKmUnderExceed,
    monitorKmOverPercentage: r.monitorKmOverPercentage,
    monitorKmUnderPercentage: r.monitorKmUnderPercentage,
    monitorKmShowOnlyOver: r.monitorKmShowOnlyOver,
    newCarEmailFieldDisabled: r.newCarEmailFieldDisabled,
    usedCarEmailFieldDisabled: r.usedCarEmailFieldDisabled,
    tyreHotelEmailFieldDisabled: r.tyreHotelEmailFieldDisabled,
    prolongingsEmailFieldDisabled: r.prolongingsEmailFieldDisabled,
    serviceIntervalsEmailFieldDisabled: r.serviceIntervalsEmailFieldDisabled,
    monitorKmEmailFieldDisabled: r.monitorKmEmailFieldDisabled,
  };
  return dealer;
}

function mapDealer(response: Response): Dealer {
  // toPerson looks just like in the previous example
  return toDealer(response.json());
}

// this could also be a private method of the component class
function handleError(error: any) {
  // log error
  // could be something more sofisticated
  let errorMsg =
    error.message ||
    `Yikes! There was was a problem with our hyperdrive device and we couldn't retrieve your data!`;
  console.error(errorMsg);

  // throw an application level error
  return Observable.throw(errorMsg);
}



// WEBPACK FOOTER //
// ./src/app/_services/dealers.service.ts